export default "__VITE_ASSET__fec35d01__"